import React from 'react';
import { Link } from 'react-router-dom';
interface WordmarkProps {
  tone?: 'dark' | 'light';
  className?: string;
}
export function Wordmark({
  tone = 'dark',
  className = ''
}: WordmarkProps) {
  const primary = tone === 'dark' ? 'text-navy' : 'text-white';
  const secondary = tone === 'dark' ? 'text-copper' : 'text-aluminum';
  return <Link to="/" className={`group inline-flex flex-col leading-none ${className}`} aria-label="Robertson Precision — home" data-id="element-370" data-mp="6k29j18p3z8g">
      <span className={`font-display text-[15px] sm:text-[17px] font-semibold tracking-[0.18em] ${primary}`} data-id="element-371" data-mp="3ayiqfnqj23r1">
        ROBERTSON PRECISION
      </span>
      <span className="mt-1.5 flex items-center gap-2" data-id="element-372" data-mp="3f2i1hqt1gad0">
        <span aria-hidden="true" className={`h-px w-5 ${tone === 'dark' ? 'bg-copper' : 'bg-copper'}`} data-id="element-373" data-mp="3k0jhg2v63tk9" />
        <span className={`font-mono text-[9px] sm:text-[10px] tracking-label ${secondary}`} data-id="element-374" data-mp="u9wllgl6xjrn">
          SHEAR GEOMETRY TOOLING
        </span>
      </span>
    </Link>;
}